import { CurrencyPosition } from './CurrencyPosition';
import { Accounts } from './Accounts';

export class Position {

  clientAccountCurrency: string;
  cashPosition: number;
  netEquityPosition: number;
  netOpenPosition: number;
  unrealizedProfitOrLoss: number;
  ccyPositions: any;
  account: Accounts;
  // errors: ErrorDto;

  constructor() {
    this.ccyPositions = new Map<string, CurrencyPosition>();
    // this.errors = new ErrorDto();
  }
}
